const initializeAutoOpenQuiz = () => {
  /**
   * @param {string | null | undefined} value
   */
  const lower = (value) => (value ?? "").toLowerCase();
  const MAX_ATTEMPTS = 60;
  const RETRY_DELAY = 200;

  /**
   * @param {HTMLAnchorElement | null} trigger
   */
  const resolvePopupUrl = (trigger) => {
    if (!trigger) {
      return null;
    }
    const dataSet = trigger.dataset || {};
    const explicitUrl = dataSet.tfPopupUrl || null;
    if (explicitUrl) {
      return explicitUrl;
    }
    const popupId = trigger.getAttribute("data-tf-popup") || null;
    if (!popupId) {
      return null;
    }
    if (popupId.startsWith("http")) {
      return popupId;
    }
    return `https://form.typeform.com/to/${popupId}`;
  };

  /**
   * @param {HTMLAnchorElement | null} trigger
   */
  const openWithTypeform = (trigger) => {
    const popupUrl = resolvePopupUrl(trigger);
    const typeform = globalThis.tf;
    if (!popupUrl || typeof typeform?.createPopup !== "function") {
      return false;
    }
    try {
      typeform
        .createPopup(popupUrl, {
          mode: "popup",
          hideHeaders: true,
          hideFooter: true,
        })
        .open();
      return true;
    } catch (error) {
      console.error("Auto open quiz popup error", error);
      return false;
    }
  };

  /**
   * @param {HTMLAnchorElement} trigger
   */
  const triggerClick = (trigger) => {
    const clickEvent = new MouseEvent("click", { bubbles: true, cancelable: true });
    const dispatchResult = trigger.dispatchEvent(clickEvent);
    return dispatchResult === false || clickEvent.defaultPrevented === true;
  };

  /**
   * @param {number} attempt
   */
  const attemptOpen = (attempt = 0) => {
    /** @type {HTMLAnchorElement | null} */
    const trigger = document.querySelector("a[data-tf-popup]");
    if (!trigger) {
      if (attempt < MAX_ATTEMPTS) {
        globalThis.setTimeout(() => attemptOpen(attempt + 1), RETRY_DELAY);
      }
      return;
    }

    const typeform = globalThis.tf;
    const typeformReady = typeof typeform?.createPopup === "function";
    if (!typeformReady) {
      if (attempt < MAX_ATTEMPTS) {
        globalThis.setTimeout(() => attemptOpen(attempt + 1), RETRY_DELAY);
      } else {
        triggerClick(trigger);
      }
      return;
    }

    if (openWithTypeform(trigger)) {
      return;
    }

    if (triggerClick(trigger)) {
      return;
    }

    if (attempt < MAX_ATTEMPTS) {
      globalThis.setTimeout(() => attemptOpen(attempt + 1), RETRY_DELAY);
    }
  };

  const ensureAutoOpen = () => {
    if (globalThis.autoOpenQuizInitialized === true) {
      return;
    }

    const { location } = globalThis;
    // Only auto-open on homepage to avoid interrupting user flows on other pages
    if (!location || location.pathname !== "/") {
      return;
    }

    const hash = lower(location.hash);
    const searchParams = new URLSearchParams(location.search);
    const quizParam = lower(searchParams.get("quiz"));
    const sourceParam = lower(searchParams.get("source"));
    const hasQuizFlag =
      searchParams.has("quiz") &&
      (quizParam === "" ||
        quizParam === "1" ||
        quizParam === "true" ||
        quizParam === "yes" ||
        quizParam === "open" ||
        quizParam === "takethequiz" ||
        quizParam === "take-the-quiz");
    const shouldAutoOpen =
      hash === "#take-the-quiz" ||
      hash === "#takethequiz" ||
      searchParams.has("take-the-quiz") ||
      searchParams.has("takethequiz") ||
      hasQuizFlag ||
      sourceParam === "quiz";

    if (!shouldAutoOpen) {
      return;
    }
    globalThis.autoOpenQuizInitialized = true;

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", () => attemptOpen());
    } else {
      attemptOpen();
    }
  };

  ensureAutoOpen();
};

if (globalThis.autoOpenQuizScriptLoaded !== true) {
  globalThis.autoOpenQuizScriptLoaded = true;
  initializeAutoOpenQuiz();
}
